module.exports = __webpack_public_path__ + "static/media/profilepic1.afb2e235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Profile/profilepic1.jpg
// module id = 35
// module chunks = 0